module.exports = __webpack_public_path__ + "static/media/user.f663d01c.svg";